import { Component, OnInit, OnDestroy } from "@angular/core";
import { Item } from "src/app/models/item.model";
import {
  ItemService,
  PushNotificationService,
  AlertService,
} from "../../../services/service.index";
import { NgForm } from "@angular/forms";
import Swal from "sweetalert2";
import { Router } from "@angular/router";
import { AuthService } from "../../../services/service.index";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-marketing",
  templateUrl: "./marketing.component.html",
  styles: [],
})
export class MarketingComponent implements OnInit, OnDestroy {
  data = [
    { id: 0, name: "Imagen" },
    { id: 1, name: "Video" },
  ];
  isImgOrVideo = this.data[0];

  data2 = [
    { id: 0, name: "Noticia" },
    { id: 1, name: "Contenido" },
  ];
  isPostType = this.data2[0];

  categoryData = [
    { id: 0, name: "Forex / Futuros", tag: "newdist" },
    { id: 1, name: "Índices Sintéticos", tag: "actionplans" },
    { id: 2, name: "Cryptos", tag: "digitalmark" },
  ];
  isCategory = this.categoryData[0];

  subCategoryData = [
    { id: 0, name: "Principiante", section: "beginner" },
    { id: 1, name: "Básico", section: "basic" },
    { id: 2, name: "Intermedio", section: "intermediate" },
    { id: 3, name: "Avanzado", section: "advanced" },
  ];
  isSubCategory = this.subCategoryData[0];

  count: any;
  loading = true;
  items: Item[] = [];
  LastEvaluatedKey = null;
  tag = "marketing";
  item: Item = new Item("", "", "");
  file: any;
  page = 0;
  minidx = 0;
  itemsPerPage = 15;
  private unsubscribe$ = new Subject<void>();
  disabledPush: boolean;

  constructor(
    public itemService: ItemService,
    public _router: Router,
    private auth: AuthService,
    public pushNotification: PushNotificationService,
    private alertService: AlertService
  ) {
    if (!localStorage.getItem("isAdmin")) {
      this._router.navigate([`/home`]);
    }
  }

  ngOnInit() {
    this.loadItems();
    this.getMessage();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getMessage() {
    this.alertService.getAdminMessage().then((res) => {
      res.subscribe((alert: any) => {
        this.disabledPush = alert.disabledPush;
      });
    });
  }

  loadItems() {
    this.items = [];
    this.loading = true;
    if (this.isPostType.name === "Noticia") {
      this.itemService
        .getItems(`${this.tag}/news`, this.LastEvaluatedKey)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (res: any) => {
            this.items = res.data;
            this.count = this.items.length;
            this.items = intoPages(this.items, this.itemsPerPage);
            this.loading = false;
          },
          (error) => {
            if (error.status === 0 || error.status === 403) {
              this.auth.getToken();
              this.loadItems();
            }
          }
        );
    } else {
      console.log(this.isCategory.tag);
      this.itemService
        .getItems(`${this.tag}/${this.isCategory.tag}`, this.LastEvaluatedKey)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (res: any) => {
            this.items = res.data;
            this.count = this.items.length;
            this.items = intoPages(this.items, this.itemsPerPage);
            this.loading = false;
          },
          (error) => {
            if (error.status === 0 || error.status === 403) {
              this.auth.getToken();
              this.loadItems();
            }
          }
        );
    }
  }

  loadSearch(searchKey: any) {
    if (searchKey.length === 0) {
      this.loading = true;
      this.loadItems();
    } else {
      this.itemService
        .searchItemByName(searchKey, this.tag)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res: any) => {
          this.items = JSON.parse(res.body);
          this.count = JSON.parse(res.count);
          this.items
            .sort((a, b) => {
              const date1: any = new Date(a.cdate);
              const date2: any = new Date(b.cdate);
              return date1 - date2;
            })
            .reverse();
          this.items = intoPages(this.items, this.itemsPerPage);
          if (res.LastEvaluatedKey !== "") {
            this.LastEvaluatedKey = res.LastEvaluatedKey;
          }

          this.loading = false;
        });
    }
  }

  getFileFromFileUpload(file: File) {
    this.file = file;
  }
  addItem(form: NgForm) {
    if (form.valid) {
      this.item.name = form.value.name;
      this.item.description = form.value.description;
      this.item.stream_url = form.value.stream_url;
      this.item.clickMe = form.value.clickme;
      if (form.value.isMembersOnly) {
        this.item.isMembersOnly = true;
      }else {
        this.item.isMembersOnly = false; // Explicitly set to false if checkbox is not selected
    }
 
      if (form.value.isGoldPlan) {
        this.item.isMembersOnly = true;
        this.item.isGoldPlan = true;
    } else {
        this.item.isGoldPlan = false; // Explicitly set to false if checkbox is not selected
    }
      if (this.isPostType.name === "Noticia") {
        this.item.tags.push(`${this.tag}:news`);
      } else {
        this.item.tags.push(`${this.tag}:${this.isCategory.tag}`);
      }
 
      this.item.section = this.isSubCategory.section.toLowerCase();
      Swal.fire({
        title: "Agregando el ítem!",
        html: "Espere unos segundos.",
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      if (this.isImgOrVideo.name !== "Video") {
        if (this.file) {
          this.itemService
            .uploadFile(this.file, this.tag)
            .then((link: any) => {
              this.item.item_picture = link;
            })
            .catch((err: Error) => {
              Swal.close();
              Swal.fire(
                "Ítem no ha sido creado con éxito!",
                "Su ítem no ha sido creado por problemas con la imagen.",
                "error"
              );
              form.reset();
            })
            .finally(() => {
              try {
                this.createItem(this.item);
              } catch (err) {
                Swal.fire(
                  "El ítem no ha sido creado!",
                  "Contacte a soporte.",
                  "error"
                );
                console.log(err);
              }
            });
        } else {
          Swal.fire(
            "El ítem no ha sido creado!",
            "Debe de ingresar un archivo de imagen válido.",
            "error"
          );
        }
      } else {
        this.item.video_url = form.value.video;
        this.createVideoItem(this.item);
      }
      if (form.value.ispush) {
        this.pushNotification
          .postPushNotificationToActives(this.item)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (pushRes: any) => {
              // console.log(pushRes);
            },
            (error) => {
              // console.log(error);
            }
          );
      }
    }
  }

  createItem(item: Item) {
    return this.itemService
      .postItem(item)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res: any) => {
          this.item.itemId = res.id;
          this.itemService.updateMembershipForItem(item)
        },
        (error) => {
          Swal.fire(
            "Item no ha sido creado con éxito!",
            "Su item no ha sido creado contacte a soporte si persiste el problema.",
            "error"
          );
        },
        () => {
          Swal.fire(
            "Ítem creado con éxito!",
            "Su ítem creado podrá ser visualizado en la aplicación.",
            "success"
          ).then(() => {
            this.loadItems();
            this._router
              .navigateByUrl("/", { skipLocationChange: true })
              .then(() => this._router.navigate([`/items/pasoapaso`]));
          });
        }
      );
  }

  createVideoItem(item: Item) {
    return this.itemService
      .postVideoItem(item)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res: any) => {
          this.item.itemId = res.id;
          this.itemService.updateMembershipForItem(item)
        },
        (error) => {
          Swal.fire(
            "Ítem no ha sido creado con éxito!",
            "Su ítem no ha sido creado contacte a soporte si persiste el problema.",
            "error"
          );
        },
        () => {
          Swal.fire(
            "Ítem creado con éxito!",
            "Su ítem creado podrá ser visualizado en la aplicación.",
            "success"
          ).then(() => {
            this.loadItems();
            this._router
              .navigateByUrl("/", { skipLocationChange: true })
              .then(() => this._router.navigate([`/items/pasoapaso`]));
          });
        }
      );
  }
  refresh(): void {
    window.location.reload();
  }

  updateItem(form: NgForm) {
    if (form.valid) {
      if (form.value.name !== "") {
        this.item.name = form.value.name;
      }
      if (form.value.description !== "") {
        this.item.description = form.value.description;
      }
      if (form.value.stream_url !== "") {
        this.item.stream_url = form.value.stream_url;
      }
      if (form.value.clickme !== "") {
        this.item.clickMe = form.value.clickme;
      }
    
      if (form.value.isMembersOnly) {
        this.item.isMembersOnly = true;
      }else {
        this.item.isMembersOnly = false; // Explicitly set to false if checkbox is not selected
    }
 
      if (form.value.isGoldPlan) {
        this.item.isMembersOnly = true;
        this.item.isGoldPlan = true;
    } else {
        this.item.isGoldPlan = false; // Explicitly set to false if checkbox is not selected
    }
      if (this.item.video_url !== undefined) {
        if (form.value.video_url !== "") {
          this.item.video_url = form.value.video_url;
        }
        Swal.fire({
          title: "Editando el ítem!",
          html: "Espere unos segundos.",
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });
        const putItem = this.itemService
          .putAndSetMembershipVideo(this.item)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (res: any) => {},
            (err: any) => {
              Swal.close();
              Swal.fire(
                "Ítem no ha sido editado con éxito!",
                "Los cambios no se podrán ser visualizados en la aplicación. ",
                "success"
              );
            },
            () => {
              Swal.close();
              Swal.fire(
                "Ítem editado con éxito!",
                "Los cambios al editado podrán ser visualizados en la aplicación. ",
                "success"
              ).then((res: any) => {
                putItem.unsubscribe();
              });
            }
          );
        this.item = new Item("", "", "");
      } else {
        Swal.fire({
          title: "Editando el ítem!",
          html: "Espere unos segundos.",
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });
        const putItem = this.itemService
          .putAndSetMembership(this.item)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (res: any) => {},
            (err: any) => {
              Swal.close();
              Swal.fire(
                "Ítem no ha sido editado con éxito!",
                "Los cambios no se podrán ser visualizados en la aplicación. ",
                "success"
              );
            },
            () => {
              Swal.close();
              Swal.fire(
                "Ítem editado con éxito!",
                "Los cambios al editado podrán ser visualizados en la aplicación. ",
                "success"
              ).then((res: any) => {
                putItem.unsubscribe();
              });
            }
          );
        this.item = new Item("", "", "");
      }
    }
  }

  parseTags(tagsFromItem: string): any {
    if (tagsFromItem.length > this.tag.length) {
      return true;
    } else {
      return false;
    }
  }

  firstPage() {
    this.page = 0;
    this.minidx = 0;
  }

  setPage(pageNumber: any) {
    this.page = pageNumber;
  }

  incPage() {
    if (this.page < this.items.length - 1) {
      this.page = this.page + 1;
      if (this.page >= this.minidx + 9) {
        if (this.minidx + 10 < this.items.length) {
          this.minidx = this.minidx + 1;
        }
      }
    }
  }

  decPage() {
    if (this.page > 0) {
      this.page = this.page - 1;
      if (this.page < this.minidx + 1) {
        if (this.minidx > 0) {
          this.minidx = this.minidx - 1;
        }
      }
    }
  }

  loadItemModal(itemToModal: Item) {
    this.item = itemToModal;
  }

  deleteItem(item: Item) {
    let deleteItem: any;
    Swal.fire({
      title: "Estás seguro?",
      text: "Se eliminara el item: " + item.name,
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#06d79c",
      cancelButtonColor: "#ef5350",
      confirmButtonText: "Si",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: "Editando el item!",
          html: "Espere unos segundos.",
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });
        deleteItem = this.itemService
          .deleteItem(item.itemId)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (res: any) => {},
            (error) => {
              Swal.close();
              Swal.fire("Error", "El item no ha sido eliminado.", "error");
            },
            () => {
              Swal.close();
              Swal.fire("Eliminado", "El item ha sido eliminado.", "success");
              this.loadItems();
              deleteItem.unsubscribe();
            }
          );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }
}

export function intoPages(arr: any, pagelen: any) {
  const out = [];
  if (pagelen > arr.length) {
    out.push(arr);
  } else {
    for (let i = 0; i < Math.ceil(arr.length / pagelen); i++) {
      out.push(arr.slice(i * pagelen, (i + 1) * pagelen));
    }
  }
  return out;
}
